<template>
    <div>
        <v-container grid-list-md>
            <v-layout row wrap>
               
               <v-flex xs12 md3>
                    <v-select
                        :items="busquedaSel"
                        v-model="busqueda"
                        label="Sección de búsqueda"
                        
                    ></v-select>
                </v-flex>

                <v-flex v-if="busqueda === 1" xs12 md6>
                  <v-autocomplete
                        v-if="!todos"
                        v-model="empleado"
                        :items="empleadoSel"
                        label="Empleado(s)"
                        persistent-hint
                        item-text="nombre"
                        item-value="nombre"
                        multiple
                        return-object
                        @change="buscar()"
                        no-data-text="No hay registros"
                 
                    >
                        <template v-slot:selection="data">
                            <v-chip
                                :selected="data.selected"
                                close
                                class="chip--select-multi"
                                @input="removeUserItem(data.item)"
                            >
                                {{ data.item.nombre }}
                            </v-chip>
                        </template>
                        <template v-slot:item="data">
                            <template>
                            <v-list-tile-content>
                                <v-list-tile-title>{{ data.item.nombre }}</v-list-tile-title>
                            </v-list-tile-content>
                            </template>
                        </template>
                    </v-autocomplete>
                    <v-autocomplete v-if="todos" label="Todos los empleados" :disabled="todos"> </v-autocomplete>
                </v-flex>

                <v-flex xs12 md3 v-if="busqueda===1">
                    <v-checkbox color="primary" v-model="todos" label="Seleccionar todos" @change="buscar()"></v-checkbox>
                    
                </v-flex>
                
                <v-flex v-if="busqueda === 2 " xs12 md6>
                      <v-autocomplete
                      v-if="!todosDep"
                        v-model="dependencia"
                        :items="dependenciaSel"
                        label="Dependencia(s)"
                        persistent-hint
                        item-text="nombre"
                        item-value="nombre"
                        multiple
                        return-object
                        @change="buscar()"
                      
                    >
                        <template v-slot:selection="data">
                            <v-chip
                                :selected="data.selected"
                                close
                                class="chip--select-multi"
                                @input="removeDepItem(data.item)"
                            >
                                {{ data.item.nombre }}
                            </v-chip>
                        </template>
                        <template v-slot:item="data">
                            <template>
                            <v-list-tile-content>
                                <v-list-tile-title>{{ data.item.nombre }}</v-list-tile-title>
                            </v-list-tile-content>
                            </template>
                        </template>
                    </v-autocomplete>
                    <v-autocomplete v-if="todosDep" label="Todas las dependencias" :disabled="todosDep"> </v-autocomplete>
                </v-flex> 
                 <v-flex xs12 md3 v-if="busqueda===2">
                    <v-checkbox color="primary" v-model="todosDep" label="Seleccionar todas" @change="buscar()"></v-checkbox>
                </v-flex>
                <!-- <v-flex v-if="busqueda === 3" xs12 sm6 md9>
                    <v-autocomplete
                        v-model="puesto"
                        :items="puestoSel"
                        label="Puesto(s)"
                        persistent-hint
                        item-text="nombre"
                        item-value="nombre"
                        multiple
                        return-object
                    >
                        <template v-slot:selection="data">
                            <v-chip
                                :selected="data.selected"
                                close
                                class="chip--select-multi"
                                @input="removePueItem(data.item)"
                            >
                                {{ data.item.nombre }}
                            </v-chip>
                        </template>
                        <template v-slot:item="data">
                            <template>
                            <v-list-tile-content>
                                <v-list-tile-title>{{ data.item.nombre }}</v-list-tile-title>
                            </v-list-tile-content>
                            </template>
                        </template>
                    </v-autocomplete>
                </v-flex> -->
            </v-layout>

            <v-layout v-if="busqueda !== 4" row wrap>
                    <v-flex xs12 sm3 md3>
                        <v-menu
                            v-model="inicioCal"
                            :close-on-content-click="false"
                            full-width
                            max-width="290"
                            >
                            <v-text-field
                                :value="fechaInicioText"
                                label="Fecha inicial"
                                slot="activator"
                                readonly
                            ></v-text-field>
                            <v-date-picker
                                v-model="fechaInicio"
                                @change="inicioCal = false, buscar()"
                                locale="es"
                                reactive
                                :max="inicioMax"
                          
                            ></v-date-picker>
                        </v-menu>
                    </v-flex>

                    <v-flex xs12 sm3 md3>
                        <v-menu
                            v-model="finCal"
                            :close-on-content-click="false"
                            full-width
                            max-width="290"
                         
                            >
                            <v-text-field
                                :value="fechaFinText"
                                label="Fecha final"
                                slot="activator"
                                readonly
                            ></v-text-field>
                            <v-date-picker
                                v-model="fechaFin"
                                @change="finCal = false, buscar()"
                                locale="es"
                                reactive
                                
                            ></v-date-picker>
                        </v-menu>
                    </v-flex>

                    <v-flex v-if="resultados.length != 0">
                
                           <v-tooltip top>
                                <v-btn  fab dark small color="green" slot="activator" @click="descargar()">
                                    <v-icon  dark>fas fa-file-excel</v-icon>
                                </v-btn>
                                <span>Descargar Excel</span>
                            </v-tooltip>
                    </v-flex>

            </v-layout>

            <v-layout v-else row wrap>
                <v-flex xs12 sm2 md2>
                    <v-select
                        v-model="anio"
                        :items="anios"
                        label="Año"
                        ></v-select>
                </v-flex>
                <v-flex xs12 sm6 md6>
                    <v-select
                        v-model="quincena"
                        :items="quincenaSel"
                        label="Quincena"
                        @change="buscar()"
                        ></v-select>
                </v-flex>
                <!-- <v-flex xs12 sm2 md2>
                    <v-btn depressed small color="primary" @click="buscar()">Buscar</v-btn>
                </v-flex> -->
            </v-layout>

            <v-layout row wrap>
                <v-flex xs12 sm12 md12>
                    <resultados v-if="busqueda !== 4" 
                        :resultados="resultados"
                        :localidades="localidades"
                        @enviandoStart="enviandoStart"
                        @enviandoStop="enviandoStop"
                    />
                </v-flex>
            </v-layout>

        </v-container>
    </div>
</template>

<script>
import { mapGetters } from "vuex";
import axios from 'axios'
import moment from 'moment'
moment.locale('es');

import Resultados from './resultados'

export default {
    name: 'Busqueda',
    props:['empleados','dependencias','puestos','localidades'],
    components:{ Resultados },
    computed: {
        ...mapGetters(["sessionToken","httpURL","userId","tableProps","permisos","role"]),
        icon () {    
            if (this.dependencia.length === this.dependenciaSel.length) return "fas fa-trash-alt"
            if (this.dependencia.length > 0 && this.dependencia.length !== this.dependenciaSel.length) return 'fas fa-check'
            return "fas fa-circle"
        },
        iconEmpleados () {    
        if (this.empleado.length === this.empleadoSel.length) return "fas fa-trash-alt"
        if (this.empleado.length > 0 && this.empleadoSel.length !== this.empleadoSel.length) return 'fas fa-check'
        return "fas fa-circle"
      },
        puedeAgregarHorario(){
            return this.role == 'administrador' || this.permisos.findIndex(x => x.numero === 176) >= 0 
        },
        fechaInicioText(){
          moment.locale('es');
          return this.fechaInicio ? moment(this.fechaInicio).format('LL') : ''
        },
        fechaFinText(){
          moment.locale('es');
          return this.fechaFin ? moment(this.fechaFin).format('LL') : ''
        },
        inicioMax(){
            if( this.fechaInicio && this.fechaFin ){
                let inicio = moment(this.fechaInicio);
                let fin = moment(this.fechaFin);
                fin.add(-1,'days');
                if( inicio >= fin ){
                    this.fechaInicio = fin.format('YYYY-MM-DD');
                }
                return fin.format('YYYY-MM-DD');
            }else
                return null;
        }
    },
    watch:{
        'dependencias':function(val){
            if(val.length>0)this.dependenciaSel=this.dependencias
        },
        'empleados':function(val){
            if(val.length>0)this.empleadoSel=this.empleados
        },
        'todos': function(val){
             if(!val) this.empleado=[]
        },
        'todosDep': function(val){
             if(!val) this.dependencia=[]
        }
    },
    mounted(){
        if(this.dependencias.length>0) this.dependenciaSel=this.dependencias
        if(this.empleados.length>0) this.empleadoSel=this.empleados
    },
    data() {
        return {
     
            busqueda: 1,
            busquedaSel: [
                {value:1,text:'Empleado'},
                {value:2,text:'Dependencia'},
                // {value:3,text:'Puesto'}
            ],
            empleado: [],
            dependencia: [],
            //puesto: null,
            empleadoSel: [],
            dependenciaSel: [],
            //puestoSel: [],
            fechaInicio: null,
            inicioCal:false,
            fechaFin: null,
            finCal:false,
            anio: '2019',
            anios: ['2019','2020','2021'],
            quincena:1,
            quincenaSel:[],
            calculos:[],
            resultados:[],
            todos:false,
            todosDep:false,
          
        }
    },
    beforeMount(){
 
        this.puestoSel = this.puestos;
        this.fechaFin = moment().format('YYYY-MM-DD');
        this.fechaInicio = moment().add(-7,'days').format('YYYY-MM-DD');
        //Se calculan las quincenas
        let numero = 1;
        for(let i=0; i<12; i++){
            this.quincenaSel.push({value:numero++,text:'Primera de '+moment().month(i).format('MMMM')});
            this.quincenaSel.push({value:numero++,text:'Segunda de '+moment().month(i).format('MMMM')});
        }
    },
    methods:{
   
        enviandoStart(){
            this.$emit('enviandoStart');
        },
        enviandoStop(){
            this.$emit('enviandoStop');
        },
        removeUserItem (item) {
            const index = this.empleado.findIndex(x=>x._id == item._id);
            if (index >= 0) this.empleado.splice(index, 1)
        },
        removeDepItem (item) {
            const index = this.dependencia.findIndex(x=>x._id == item._id);
            if (index >= 0) this.dependencia.splice(index, 1)
        },
        removePueItem (item) {
            const index = this.puesto.findIndex(x=>x._id == item._id);
            if (index >= 0) this.puesto.splice(index, 1)
        },
        usuariosEmp(){
            let usuarios=[]
                if(this.todos){
                    if(this.empleados.length > 0) usuarios= this.empleados.map(element => {return element._id});                  
                }
                else{
                     if(this.empleado.length > 0) usuarios = this.empleado.map(element => {return element._id});
                }
                return usuarios;
        },
        dep(){
            let dep=[]
            if(this.todosDep){
                if(this.dependencias.length > 0) dep= this.dependencias.map(element => {return element._id});
            }
            else{
                if(this.dependencia.length > 0) dep = this.dependencia.map(element => {return element._id});
            }
            return dep;
        },
        buscar(){
            if( this.busqueda === 1 ){
                this.enviandoStart();
                let usuarios = this.usuariosEmp();
                if(usuarios.length>0){
              

                axios.post(this.httpURL+'/asistencias/listado/usuarios',
                    {
                        usuarios: usuarios.toString(),
                        inicio: this.fechaInicio,
                        fin: this.fechaFin
                    },
                    {headers:{token: this.sessionToken}})
                    .then(res => {
                        this.enviandoStop();
                        this.resultados = res.data.resultados;
                        this.$notify({ group: 'foo_notif', type:'success', duration:3500, text: res.data.mensaje});
                    })
                    .catch(error => {
              
                        this.enviandoStop();
                        this.$notify({ group: 'foo_notif', type:'error', duration:4000, text: error.response.data.mensaje});
                    });
                }
                else {
                    this.resultados=[]
                    this.enviandoStop();
                }
                
            }
            if( this.busqueda === 2 ){                  
                this.enviandoStart();
                let dependencias = this.dep();
                if(dependencias.length>0){
                    axios.post(this.httpURL+'/asistencias/listado/dependencias',
                        {
                            dependencias: dependencias.toString(),
                            inicio: this.fechaInicio,
                            fin: this.fechaFin
                        },
                        {headers:{token: this.sessionToken}})
                        .then(res => {
                            this.resultados = res.data.resultados;
                            this.enviandoStop();
                            this.$notify({ group: 'foo_notif', type:'success', duration:3500, text: res.data.mensaje});
                        })
                        .catch(error => {
                            // console.log(error);
                            this.enviandoStop();
                            this.$notify({ group: 'foo_notif', type:'error', duration:4000, text: error.response.data.mensaje});
                        });
                }
                else {
                    this.resultados=[]
                    this.enviandoStop();
                }
                }
            
        },
        depCalculada(id){
            let index = this.calculos.findIndex(x=> x._id == id);
            if( index >= 0)
                this.calculos[index].status = 'Calculado';
        },
         descargar(){
            if( this.busqueda === 1 ){
                this.enviandoStart();
                let usuarios = this.usuariosEmp();
                if(usuarios.length>0){
                axios.post(this.httpURL+'/asistencias/descargar/usuarios',
                    {
                        usuarios: usuarios.toString(),
                        inicio: this.fechaInicio,
                        fin: this.fechaFin
                    },
                    {headers:{token:this.sessionToken},responseType: 'blob'})
                    .then(response => {
                    //  console.log(response)
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', 'asistencias.xlsx');
                    document.body.appendChild(link);
                    link.click();
                    this.enviandoStop()
                    this.$notify({ group: 'foo_notif', type:'success', duration:3500, text: "Archivo descargado correctamente"});
                    })
                    .catch(error => {
                        //console.log(error);
                        this.enviandoStop();
                        this.$notify({ group: 'foo_notif', type:'error', duration:4000, text: error.response.data.mensaje});
                    });
                }
                else this.enviandoStop()
            }
            if( this.busqueda === 2 ){
               
                this.enviandoStart();
                let dependencias = this.dep();
                if(dependencias.length>0){
                    axios.post(this.httpURL+'/asistencias/descargar/dependencias',
                        {
                            dependencias:dependencias.toString(),
                            inicio: this.fechaInicio,
                            fin: this.fechaFin
                        },
                        {headers:{token:this.sessionToken},responseType: 'blob'})
                        .then(response => {
                        // console.log(response)
                        const url = window.URL.createObjectURL(new Blob([response.data]));
                        const link = document.createElement('a');
                        link.href = url;
                        link.setAttribute('download', 'Asistencias.xlsx');
                        document.body.appendChild(link);
                        link.click();
                        this.enviandoStop()
                       this.$notify({ group: 'foo_notif', type:'success', duration:3500, text: "Archivo descargado correctamente"});
                        })
                        .catch(error => {
                            // console.log(error);
                            this.enviandoStop();
                            this.$notify({ group: 'foo_notif', type:'error', duration:4000, text: error.response.data.mensaje});
                        });
                }
                else this.enviandoStop()
            }
            
        },
      
    }
}
</script>